import "../../font.css.ts.vanilla.mjs";
import "./button.css.ts.vanilla.mjs";
var r = "p273__button-e565_addb864__18r589f2", e = "p273__button-e565_addb864__18r589f1", a = "p273__button-e565_addb864__18r589f0";
export {
  r as buttonStyle,
  e as darkTheme,
  a as lightTheme
};
//# sourceMappingURL=button.mjs.map
